import React, { useContext, useEffect, useState } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import { useAuth } from '../../Contexts/AuthContext';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Divider from '../ERUMAUI/UI_Divider';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Toggle from '../ERUMAUI/UI_Toggle';
import UI_Card from '../ERUMAUI/UI_Card';
import UI_List_Manager from '../ERUMAUI/UI_List_Manager';
import UI_Input_Date from '../ERUMAUI/UI_Input_Date';

import { useReporting } from '../../Contexts/Context_Reporter';

import Controls_ScheduleManagement_Timetable_Selector from '../ScheduleManagement/Controls_ScheduleManagement_Map_Selector';
import Controls_Map_Selector from '../InteractiveMap/Controls_Map_Selector';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import UI_Dropdown_New from '../ERUMAUI/UI_Dropdown_New';
import { useAccounts } from '../../Contexts/Context_Accounts';
import UI_Section_Title from '../ERUMAUI/UI_Section_Title';
import Icon_Reports from '../../Assets/Icons/Icon_Reports.png';
import Icon_Calendar from '../../Assets/Icons/Icon_Calendar.png';
import Icon_Table from '../../Assets/Icons/Icon_Table.png';
import Icon_Room from '../../Assets/Icons/Icon_Room.png';
import Icon_Map from '../../Assets/Icons/Icon_Map.png';
import Icon_ReservationSlip from '../../Assets/Icons/Icon_ReservationSlip.png';
import Icon_User from '../../Assets/Icons/Icon_User.png';
import Icon_Trail from '../../Assets/Icons/Icon_Trail.png';
import Icon_PDF from '../../Assets/Icons/Icon_PDF.png';
import Icon_Image from '../../Assets/Icons/Icon_Image.png';
import Icon_Print from '../../Assets/Icons/Icon_Print.png';




export default function Panel_Reporter_Right() {
    const { Account, Loading } = useAuth();
    const UI = useContext(Context_UI);
    const { Schedules, Schedules_ByUser, Schedule_Display, Time_Range_Parse, Status_Parse, Schedule_Information } = useScheduleManagement();
    const { User_Permission, Account_Fetch_ByID_FromState, Accounts_List } = useAccounts();
    const Account_canManage_Schedules = User_Permission?.Reservation.Edit || User_Permission?.Reservation.Approve.Initial || User_Permission?.Reservation.Final;
    const {
        Report_Type,
        Report_Schedules_Monthly,
        Export_AsPDF,
        Input_Schedules_Monthly,
        Input_Schedules_Monthly_Set,
        Input_Schedules_Timetable_Set,
        Report_Schedules_Timetable,
        Export_Map,
        Input_Room_Utilization_Set,
        Report_Room_Utilization,
        Report_Logs,
        Logs_Types,
        Logs_Categories,
        Logs_Types_Documents,
        Input_Logs,
        Input_Logs_Set,
        Report_Presentation_Set,
        Report_Presentation,
        Report_Logs_Trail,
        Input_Logs_Trail,
        Input_Logs_Trail_Set,
        Output_Logs_Trail_Set
    } = useReporting();
    const { Confirmer_Confirm } = useStatus();

    const Now = new Date();
    const Default_Start = `${Now.getFullYear()}-${String(Now.getMonth() + 1).padStart(2, "0")}`;
    const Default_End = `${Now.getFullYear()}-${String(Now.getMonth() + 1).padStart(2, "0")}`;

    const Schedule_Monthly_Handle = async (Value, Side) => {
        if (Side !== "Single") {
            if (document.getElementById("Schedule_Monthly_Start_Input_Raw") && document.getElementById("Schedule_Monthly_End_Input_Raw")) {
                const Start = document.getElementById("Schedule_Monthly_Start_Input_Raw").value.split("-");
                const End = document.getElementById("Schedule_Monthly_End_Input_Raw").value.split("-");
                const Passed = await UI.Input_Evaluate([
                    {
                        ID_Start: "Schedule_Monthly_Start",
                        ID_End: "Schedule_Monthly_End",
                        Type: "Time_Range_Month_Custom",
                        AC: "Past",
                        Prompt: "Invalid range"
                    }
                ]);
                if (Passed) {
                    Input_Schedules_Monthly_Set(Prev => ({
                        ...Prev,
                        Month_Start: Start[1],
                        Year_Start: Start[0],
                        Month_End: End[1],
                        Year_End: End[0]
                    }))
                }
            }

        } else {
            const Start = document.getElementById("Schedule_Monthly_Single_Input_Raw").value.split("-");
            Input_Schedules_Monthly_Set(Prev => ({
                ...Prev,
                Month_Start: Start[1],
                Year_Start: Start[0],
                Month_End: Start[1],
                Year_End: Start[0]
            }))
        }

    }

    const Schedule_Monthly_Handle_Filter = async (Type, Value) => {
        if (Type === "Schedule_Monthly_Approved_Full") {
            Input_Schedules_Monthly_Set(Prev => ({
                ...Prev,
                Include_Approved_Full: Value
            }));
        }
        if (Type === "Schedule_Monthly_Approved_Partial") {
            Input_Schedules_Monthly_Set(Prev => ({
                ...Prev,
                Include_Approved_Partial: Value
            }));
        }
        if (Type === "Schedule_Monthly_Pending") {
            Input_Schedules_Monthly_Set(Prev => ({
                ...Prev,
                Include_Pending: Value
            }));
        }
        if (Type === "Schedule_Monthly_Rejected") {
            Input_Schedules_Monthly_Set(Prev => ({
                ...Prev,
                Include_Rejected: Value
            }));
        }
        if (Type === "Schedule_Monthly_Room") {
            if (Value) {
                Input_Schedules_Monthly_Set(Prev => ({
                    ...Prev,
                    Include_Room: false
                }));
            } else {
                Input_Schedules_Monthly_Set(Prev => ({
                    ...Prev,
                    Include_Room: true
                }));
            }

        }
    }

    const Schedule_Monthly_Handle_Room = (ID) => {
        if (ID) {
            Input_Schedules_Monthly_Set(Prev => ({
                ...Prev,
                RoomID: ID
            }));
        }
    }



    const [Schedule_Weekly_Room, Schedule_Weekly_Room_Set] = useState("");

    const Schedule_Weekly_Handle = async (Side) => {
        let Start_Year;
        let Start_Week;
        let End_Year;
        let End_Week;
        if (document.getElementById("Schedule_Week_Start_Input_Raw") && document.getElementById("Schedule_Week_End_Input_Raw")) {
            if (document.getElementById("Schedule_Week_Start_Input_Raw").value.split("-")[0] && document.getElementById("Schedule_Week_End_Input_Raw").value.split("-")[0]) {
                Start_Year = document.getElementById("Schedule_Week_Start_Input_Raw").value.split("-")[0];
                End_Year = document.getElementById("Schedule_Week_End_Input_Raw").value.split("-")[0];
                Start_Week = document.getElementById("Schedule_Week_Start_Input_Raw").value.split("-")[1].replace("W", "");
                End_Week = document.getElementById("Schedule_Week_End_Input_Raw").value.split("-")[1].replace("W", "");
            }
            const Passed = await UI.Input_Evaluate([
                {
                    ID_Start: "Schedule_Week_Start",
                    ID_End: "Schedule_Week_End",
                    Type: "Time_Range_Week_Custom",
                    AC: "Past",
                    Prompt: "Invalid range"
                }
            ]);

            Input_Schedules_Timetable_Set({
                Week_Start: Start_Week,
                Year_Start: Start_Year,
                Week_End: End_Week,
                Year_End: End_Year,
                RoomID: Schedule_Weekly_Room
            });
        }

    }

    useEffect(() => {
        Schedule_Weekly_Handle();
    }, [Schedule_Weekly_Room])

    const { Map_Composition, Refresh, Map_HighlightedMarker_Set, Selected_Building, Selected_Building_Set, Selected_Floor, Selected_Floor_Set, Transformer_Reference, Container_Reference } = useMapRenderer();

    const Reservation_Handle = async (ID) => {
        await Schedule_Display(ID);
    }

    const Room_Utilization_Handle_Map = async () => {
        const { Response, Data } = await Confirmer_Confirm('Window_Map_ChooseRoom');
        if (Response === "Confirmed") {
            // Input
        }
    }

    const Room_Utilization_Handle_Filter = (Value, Target) => {
        const Passed = UI.Input_Evaluate([
            {
                Type: "Time_Range_Date_Custom",
                ID_Start: "Room_Utilization_Date_Start",
                ID_End: "Room_Utilization_Date_End",
                AC: "Past",
                Prompt: "Invalid range"
            }
        ])
        if (Passed) {
            if (Target === "Date_Start") {
                Input_Room_Utilization_Set(Previous => ({
                    ...Previous,
                    Filter_Date_Start: Value
                }))
            }
            if (Target === "Date_End") {
                Input_Room_Utilization_Set(Previous => ({
                    ...Previous,
                    Filter_Date_End: Value
                }))
            }
        } else {
            Input_Room_Utilization_Set(Previous => ({
                ...Previous,
                Filter_Date_Start: null,
                Filter_Date_End: null
            }));
        }
    }

    const [List_Logs_Actions, List_Logs_Actions_Set] = useState(Logs_Types);

    useEffect(() => {
        const Handle_Search_Specifity = ({ ID, Tab_Active }) => {
            if (ID === "Log_Specifity ") {
                if (Tab_Active === "Tab_Get_All") {
                    Input_Logs_Set(Previous => ({
                        ...Previous,
                        Search_Type: "All"
                    }));
                }
                if (Tab_Active === "Tab_Search_General") {
                    Input_Logs_Set(Previous => ({
                        ...Previous,
                        Search_Type: "General"
                    }));
                }
                if (Tab_Active === "Tab_Search_Advanced") {
                    Input_Logs_Set(Previous => ({
                        ...Previous,
                        Search_Type: "Advanced"
                    }));
                }
            }
        }
        const Handle_Filter = ({ List_ID, Value, Value_Index }) => {
            if (List_ID === "Log_Filter_Category") {
                if (Logs_Categories[Value_Index].Prefix !== "ALL") {
                    const List = Logs_Types.filter((Item) => Item.Prefix === Logs_Categories[Value_Index].Prefix);
                    List_Logs_Actions_Set(List);
                } else {
                    const List = Logs_Types
                    List_Logs_Actions_Set(List);
                }
            }
            if (List_ID === "Log_Filter_Action") {
                // console.warn(List_Logs_Actions[0][Value_Index]);
                // console.warn(List_Logs_Actions[0]);
                Input_Logs_Set(Previous => ({
                    ...Previous,
                    Filter_Action: Value
                }));
            }
        }
        UI.on("Tabs_Horizontal_Switched", Handle_Search_Specifity);
        UI.on("Dropdown_Value_Submitted", Handle_Filter);
        return () => {
            UI.off("Tabs_Horizontal_Switched", Handle_Search_Specifity);
            UI.off("Dropdown_Value_Submitted", Handle_Filter);
        }
    }, [UI]);

    const Logs_Handle_Time = () => {
        const Passed = true;
        // const Passed = UI.Input_Evaluate([
        //     {
        //         Type: "Time_Range_Custom",
        //         ID_Start: "Log_Range_Start",
        //         ID_End: "Log_Range_End",
        //         AC: "Past",
        //         Prompt: "Invalid range"
        //     }
        // ]);
        if (Passed) {
            Input_Logs_Set(Previous => ({
                ...Previous,
                Filter_Date_Start: new Date(document.getElementById("Log_Range_Start_Input_Raw").value),
                Filter_Date_End: new Date(document.getElementById("Log_Range_End_Input_Raw").value)
            }))
        }
    }

    const Logs_Handle_Search = (Value) => {
        Input_Logs_Set(Previous => ({
            ...Previous,
            Filter_SearchTerm: Value
        }))
    }

    const Logs_Handle_Filter_Action = (Item, Index) => {
        if (Item.Action) {
            Input_Logs_Set(Previous => ({
                ...Previous,
                Filter_Action: Item.Action
            }));
        }

    }

    const Logs_Handle_SearchType = (ID) => {
        if (ID === "Tab_Get_All") {
            Input_Logs_Set(Previous => ({
                ...Previous,
                Search_Type: "All"
            }));
        }
        if (ID === "Tab_Search_General") {
            Input_Logs_Set(Previous => ({
                ...Previous,
                Search_Type: "General"
            }));
        }
        if (ID === "Tab_Search_Advanced") {
            Input_Logs_Set(Previous => ({
                ...Previous,
                Search_Type: "Advanced"
            }));
        }
    }

    const Presentation_Handle = (ID) => {
        if (ID === "Tab_Normal") {
            Report_Presentation_Set("Normal");
        }
        if (ID === "Tab_Document") {
            Report_Presentation_Set("Document");
        }
    }

    const [SearchQuery_Reservations, SearchQuery_Reservations_Set] = useState("");

    const [Reservation_Content, Reservation_Content_Set] = useState([]);
    // if (Account_canManage_Schedules) {
    //     Reservation_Content_Set(Schedules);
    // } else {
    //     Reservation_Content_Set(Schedules_ByUser);
    // }

    useEffect(() => {
        if (Account_canManage_Schedules) {
            Reservation_Content_Set(Schedules);
        } else {
            Reservation_Content_Set(Schedules_ByUser);
        }
    }, [Account_canManage_Schedules, Schedules, Schedules_ByUser]);

    const Filtered_Schedules = Reservation_Content?.filter(item => {
        const query = SearchQuery_Reservations.trim().toLowerCase();
        if (!query) return true;
        return (
            item.Name.toLowerCase().includes(query) ||
            (item.Description && item.Description.toLowerCase().includes(query)) ||
            (item.RoomName && item.RoomName.toLowerCase().includes(query))
        );
    });


    const Accounts_Choose = async () => {
        const { Response, Data } = await Confirmer_Confirm('Window_Accounts_ChooseRoom');
        if (Response === "Confirmed") {
            Input_Logs_Trail_Set(Previous => ({
                ...Previous,
                ID: Data.ID
            }));
        }
    }

    const Handle_Logs_Trail_Filter = (Value, Target) => {
        const Passed = UI.Input_Evaluate([
            {
                Type: "Time_Range_Date_Custom",
                ID_Start: "User_Trail_Date_Start",
                ID_End: "User_Trail_Date_End",
                AC: "Past",
                Prompt: "Invalid range"
            }
        ])
        if (Passed) {
            if (Target === "Date_Start") {
                Input_Logs_Trail_Set(Previous => ({
                    ...Previous,
                    Filter_Date_Start: Value
                }))
            }
            if (Target === "Date_End") {
                Input_Logs_Trail_Set(Previous => ({
                    ...Previous,
                    Filter_Date_End: Value
                }))
            }
        } else {
            Input_Logs_Trail_Set(Previous => ({
                ...Previous,
                Filter_Date_Start: null,
                Filter_Date_End: null
            }));
        }
    }

    useEffect(() => {
        if (Input_Logs_Trail.ID) {
            Output_Logs_Trail_Set([]);
        }
    }, [Input_Logs_Trail.ID])

    if (Loading) {
        return null;
    }
    return (
        <>
            <UI_Horizontal_Tabs
                id="Display_Type"
                Selectors={[
                    {
                        Icon: <UI_Icon Name="See" />,
                        Text: "Normal view"
                    },
                    {
                        Icon: <UI_Icon Name="Document" />,
                        Text: "Document preview"
                    }
                ]}
                UIDs={["Normal", "Document"]}
                Selected={`Tab_${Report_Presentation}`}
                Components={[<></>, <></>]}
                onChange={(ID) => Presentation_Handle(ID)}
            />
            {Report_Type === "Schedule_Monthly" ?
                <div>
                    <UI_Section_Title
                        Text="Monthly schedule"
                        Icon={<img src={Icon_Calendar} />}
                        Margins={true}
                    />
                    <div style={{ display: "grid", gridTemplateRows: "auto auto auto", gap: "10px", marginTop: "10px" }}>
                        <UI_Horizontal_Tabs
                            id="Schedule_Monthly_Specifity"
                            Selectors={[
                                {
                                    Icon: <UI_Icon Name="User_Edit" />,
                                    Text: "Singular month"
                                },
                                {
                                    Icon: <UI_Icon Name="User_Edit" />,
                                    Text: "Multiple months"
                                }
                                // ,
                                // {
                                //     Icon: <UI_Icon Name="Schedule" />,
                                //     Text: "Advanced search"
                                // }
                            ]}
                            onChange={(ID) => Logs_Handle_SearchType(ID)}
                            UIDs={["Month_Singular", "Month_Multiple"]}
                            Selected="Tab_Month_Singular"
                            Components={[
                                <>
                                    <UI_Divider Text="Range" />
                                    <UI_Form Composition="ByTwo">
                                        <UI_Input_Date
                                            id="Schedule_Monthly_Single"
                                            Label_Text="Month"
                                            Mode="Month"
                                            Required={true}
                                            Initial_Today={true}
                                            onChange={(e) => Schedule_Monthly_Handle(e.target.value, "Single")}
                                        />
                                    </UI_Form>
                                </>,
                                <>
                                    <UI_Divider Text="Range" />
                                    <UI_Form Composition="ByTwo">
                                        <UI_Input_Date
                                            id="Schedule_Monthly_Start"
                                            Label_Text="Starting month"
                                            Mode="Month"
                                            Required={true}
                                            onChange={(e) => Schedule_Monthly_Handle(e.target.value, "Start")}
                                        />
                                        <UI_Input_Date
                                            id="Schedule_Monthly_End"
                                            Label_Text="Ending month"
                                            Mode="Month"
                                            Required={true}
                                            onChange={(e) => Schedule_Monthly_Handle(e.target.value, "End")}
                                        />
                                    </UI_Form>
                                </>
                            ]}
                        />
                        <UI_Divider Text="Filters" />
                        <UI_Toggle
                            id="Schedule_Monthly_Approved_Full"
                            Text="Fully approved"
                            Type="Switch"
                            Selected="true"
                            onClick={(State) => Schedule_Monthly_Handle_Filter("Schedule_Monthly_Approved_Full", State)}
                        />
                        <UI_Toggle
                            id="Schedule_Monthly_Approved_Partial"
                            Text="Partially approved"
                            Type="Switch"
                            Selected="false"
                            onClick={(State) => Schedule_Monthly_Handle_Filter("Schedule_Monthly_Approved_Partial", State)}
                        />
                        <UI_Toggle
                            id="Schedule_Monthly_Pending"
                            Text="Pending"
                            Type="Switch"
                            onClick={(State) => Schedule_Monthly_Handle_Filter("Schedule_Monthly_Pending", State)}
                        />
                        <UI_Toggle
                            id="Schedule_Monthly_Rejected"
                            Text="Rejected"
                            Type="Switch"
                            onClick={(State) => Schedule_Monthly_Handle_Filter("Schedule_Monthly_Rejected", State)}
                        />

                        <UI_Divider Text="Location" />
                        <Controls_ScheduleManagement_Timetable_Selector
                            onRoomSelect={(Room) => Schedule_Monthly_Handle_Room(Room)}
                            onToggle={(State) => Schedule_Monthly_Handle_Filter("Schedule_Monthly_Room", State)}
                        />
                        <UI_Divider />
                        <UI_Button
                            Text="Generate document"
                            OnClick={Report_Schedules_Monthly}
                        />
                    </div>
                </div>
                :
                ""
            }
            {Report_Type === "Schedule_Timetable" ?
                <>
                    <UI_Section_Title
                        Text="Weekly timetable"
                        Icon={<img src={Icon_Table} />}
                        Margins={true}
                    />
                    <div style={{ display: "grid", gridTemplateRows: "auto auto", gap: "10px", marginTop: "10px" }}>
                        <div>
                            <UI_Divider Text="Range" />
                            <UI_Form Composition="ByTwo">
                                <UI_Input_Date
                                    id="Schedule_Week_Start"
                                    Mode="Week"
                                    Label_Text="Starting week"
                                    Required={true}
                                    onChange={(e) => Schedule_Weekly_Handle("Week_Start")}
                                />
                                <UI_Input_Date
                                    id="Schedule_Week_End"
                                    Mode="Week"
                                    Label_Text="Ending week"
                                    Required={true}
                                    onChange={(e) => Schedule_Weekly_Handle("Week_End")}
                                />
                                {/* <UI_Input_Text
                                    id="Schedule_Week_Start"
                                    Input_Type='week'
                                    Label_Text="Starting week"
                                    Required={true}
                                    onChange={(e) => Schedule_Weekly_Handle("Week_Start")}
                                />
                                <UI_Input_Text
                                    id="Schedule_Week_End"
                                    Input_Type='week'
                                    Label_Text="Ending week"
                                    Required={true}
                                    onChange={(e) => Schedule_Weekly_Handle("Week_End")}
                                /> */}
                            </UI_Form>

                            <UI_Divider Text="Location" />
                            <Controls_ScheduleManagement_Timetable_Selector
                                onRoomSelect={(Room) => Schedule_Weekly_Room_Set(Room)}
                            />
                            <UI_Divider />
                        </div>

                        <UI_Button
                            Text="Generate report"
                            OnClick={Report_Schedules_Timetable}
                        />
                    </div>


                </>
                :
                ""
            }
            {Report_Type === "Floor_Utilization" ?
                <>
                    <UI_Section_Title
                        Text="Floor utilization"
                        Icon={<img src={Icon_Map} />}
                        Margins={true}
                    />
                    <div className='Floor_Utilization_Controls'>
                        <Controls_Map_Selector
                            Map_Composition={Map_Composition}
                            Building_Set={Selected_Building_Set}
                            Floor_Set={Selected_Floor_Set}
                            Selected_Building={Selected_Building}
                            Selected_Floor={Selected_Floor}
                        />
                    </div>
                </>
                :
                ""
            }
            {Report_Type === "Reservation" ?
                <>
                    <UI_Section_Title
                        Text="Reservation slip"
                        Icon={<img src={Icon_ReservationSlip} />}
                        Margins={true}
                    />
                    <UI_List_Manager
                        id="Schedules_List"
                        Options_Display={{
                            Composition: "Linear"
                        }
                        }
                        Input={Reservation_Content}
                        Keys_Searchable={["Name"]}
                        Filters={{
                            Status: {
                                Options: [
                                    {
                                        Label: "Fully approved",
                                        Icon: <UI_Icon Name="Check" />
                                    },
                                    {
                                        Label: "Pending for OSA approval",
                                        Icon: <UI_Icon Name="Partial" />
                                    },
                                    {
                                        Label: "Pending for GSU approval",
                                        Icon: <UI_Icon Name="Partial" />
                                    },
                                    {
                                        Label: "Rejected",
                                        Icon: <UI_Icon Name="Cross" />
                                    },
                                    {
                                        Label: "Pending",
                                        Icon: <UI_Icon Name="Pending" />
                                    }
                                ],
                                Logic: (Item, Selected) => {
                                    const Initial = Item.Approval.Initial.State;
                                    const Final = Item.Approval.Final.State;
                                    switch (Selected) {
                                        case "Fully approved":
                                            return Initial === "Approved" && Final === "Approved";
                                        case "Pending for OSA approval":
                                            return Initial === "Pending" && Final !== "Approved";
                                        case "Pending for GSU approval":
                                            return Initial === "Approved" && Final === "Pending";
                                        case "Rejected":
                                            return Initial === "Rejected" || Final === "Rejected";
                                        case "Pending":
                                            return Initial === "Pending" && Final === "Pending";
                                        case "All":
                                        default:
                                            return true;
                                    }
                                }
                            }
                        }}
                        Options_Sort={[
                            {
                                Label: "Name (A-Z)",
                                Key: "Name",
                                Direction: "Ascending"
                            },
                            // {
                            //     Label: "Newest",
                            //     Key: "Time.Start",
                            //     Direction: "Ascending"
                            // }
                            {
                                Label: "Upcoming",
                                Logic: (a, b) => {
                                    const now = new Date().setHours(0, 0, 0, 0); // Get current time as a number
                                    const timeA = new Date(a.Time.Start).getTime();
                                    const timeB = new Date(b.Time.Start).getTime();

                                    const aIsInPast = timeA < now;
                                    const bIsInPast = timeB < now;

                                    if (aIsInPast && !bIsInPast) {
                                        return 1;
                                    }

                                    if (!aIsInPast && bIsInPast) {
                                        return -1; // Pushes b to the end
                                    }

                                    return timeA - timeB;
                                }
                            }
                        ]}
                        Output={(Item) => (
                            <UI_Card
                                Type="Schedule_List"
                                Figure={{
                                    Title: Item.Name,
                                    Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                    Chip: Status_Parse(Item),
                                }}
                                Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                onClick={() => Reservation_Handle(Item._id)}
                            />
                        )}
                    />
                    {/* <div style={{ display: "grid", gridTemplateRows: "auto auto", gap: "10px", marginTop: "10px" }}>
                        <UI_Input_Text
                            Input_Placeholder="Search query"
                            onChange={(e) => SearchQuery_Reservations_Set(e.target.value)}
                        />
                        <div className='General_Grid' style={{ marginTop: "10px", marginBottom: "10px" }}>
                            {Filtered_Schedules?.map((Item) => (
                                <>

                                    <UI_Card
                                        Type="Schedule_List"
                                        Figure={
                                            {
                                                Title: Item.Name,
                                                Main: Time_Range_Parse(Item.Time.Start, Item.Time.End),
                                                Chip: Status_Parse(Item)
                                            }
                                        }
                                        Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                        onClick={() => Reservation_Handle(Item._id)}
                                    />

                                </>

                            ))}
                        </div>
                    </div> */}

                </>
                :
                ""
            }
            {Report_Type === "Accounts" ?
                <>
                    <UI_Section_Title
                        Text="Account status list"
                        Icon={<img src={Icon_User} />}
                        Margins={true}
                    />
                </>
                :
                ""
            }
            {Report_Type === "User_Trail" ?
                <>
                    <UI_Section_Title
                        Text="User trail"
                        Icon={<img src={Icon_Trail} />}
                        Margins={true}
                    />
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "10px" }}>
                        <UI_Divider />
                        <div>
                            <h3 className='General_Paragraph'>
                                {Account_Fetch_ByID_FromState(Input_Logs_Trail.ID)?.Name}
                            </h3>
                            <p className='General_Paragraph'>
                                {Account_Fetch_ByID_FromState(Input_Logs_Trail.ID)?.Email}
                            </p>
                        </div>
                        <UI_Divider />
                        <UI_Horizontal_Tabs
                            Selectors={[
                                {
                                    Icon: <UI_Icon Name="User" />,
                                    Text: "Choose user"
                                },
                                {
                                    Icon: <UI_Icon Name="Clock" />,
                                    Text: "Set parameters"
                                }
                            ]}
                            UIDs={["Trail_User", "Trail_Parameters"]}
                            Selected="Tab_Trail_User"
                            Components={[
                                <>
                                    <UI_List_Manager
                                        id="Schedules_List"
                                        Options_Display={{
                                            Composition: "Linear"
                                        }
                                        }
                                        Input={Accounts_List}
                                        Keys_Searchable={["Name_Compounded", "Email"]}
                                        Filters={{
                                            Status: {
                                                Options: [
                                                    {
                                                        Label: "Approved",
                                                        Icon: <UI_Icon Name="Check" />
                                                    },
                                                    {
                                                        Label: "Pending for approval",
                                                        Icon: <UI_Icon Name="Pending" />
                                                    },
                                                    {
                                                        Label: "Rejected",
                                                        Icon: <UI_Icon Name="Cross" />
                                                    },
                                                    {
                                                        Label: "Deactivated",
                                                        Icon: <UI_Icon Name="Cross" />
                                                    },
                                                    {
                                                        Label: "Teacher",
                                                        Icon: <UI_Icon Name="Teacher" />
                                                    },
                                                    {
                                                        Label: "Staff/OSA",
                                                        Icon: <UI_Icon Name="User" />
                                                    },
                                                    {
                                                        Label: "Administrator",
                                                        Icon: <UI_Icon Name="Administrator" />
                                                    }
                                                ],
                                                Logic: (Item, Selected) => {
                                                    const State = Item.Approval.State;
                                                    const Role = Item.Role;
                                                    switch (Selected) {
                                                        case "Fully approved":
                                                            return State === "Approved";
                                                        case "Pending for approval":
                                                            return State === "Pending";
                                                        case "Rejected":
                                                            return State === "Rejected";
                                                        case "Deactivated":
                                                            return State === "Deactivated";
                                                        case "Teacher":
                                                            return Role === "Teacher";
                                                        case "Staff/OSA":
                                                            return Role === "Staff";
                                                        case "Administrator":
                                                            return Role === "Administrator";
                                                        case "All":
                                                        default:
                                                            return true;
                                                    }
                                                }
                                            }
                                        }}
                                        Options_Sort={[
                                            {
                                                Label: "Name (A-Z)",
                                                Key: "Name_Compounded",
                                                Direction: "Ascending"
                                            },
                                            {
                                                Label: "Name (Z-A)",
                                                Key: "Name_Compounded",
                                                Direction: "Descending"
                                            }
                                        ]}
                                        Output={(Item) => (
                                            <UI_Card
                                                Type="Schedule_List"
                                                Figure={{
                                                    Title: Item.Name_Compounded,
                                                    Main: Item.Email,
                                                    Chip: [{
                                                        Text: Item.Role,
                                                        Color: "Border"
                                                    }],
                                                }}
                                                onClick={() => Input_Logs_Trail_Set(Previous => ({
                                                    ...Previous,
                                                    ID: Item._id
                                                }))}
                                                Subtype={Item._id === Input_Logs_Trail?.ID ? "Selected" : ""}
                                            // Subtype={Item._id === Schedule_Information?._id ? "Selected" : ""}
                                            // onClick={() => Select(Item._id)}
                                            // onClick={() => Reservation_Handle(Item._id)}
                                            />
                                        )}
                                    />
                                </>,
                                <UI_Form Composition="ByTwo">
                                    <UI_Input_Date
                                        id="User_Trail_Date_Start"
                                        Label_Text="Start date"
                                        Value="2025-01-01"
                                        onChange={(Data) => Handle_Logs_Trail_Filter(Data.target.value, "Date_Start")}
                                    />
                                    <UI_Input_Date
                                        id="User_Trail_Date_End"
                                        Label_Text="End date"
                                        Initial_Today={true}
                                        onChange={(Data) => Handle_Logs_Trail_Filter(Data.target.value, "Date_End")}
                                    />
                                </UI_Form>
                            ]}
                        />
                        <UI_Divider />
                        {/* <UI_Button
                            Text="Choose user from account list"
                            OnClick={Accounts_Choose}
                        /> */}
                        <UI_Button
                            Text="Generate report"
                            OnClick={Report_Logs_Trail}
                        />
                    </div>

                </>
                :
                ""
            }
            {Report_Type === "Room_Utilization" ?
                <>
                    <UI_Section_Title
                        Text="Room utilization"
                        Icon={<img src={Icon_Room} />}
                        Margins={true}
                    />
                    <div style={{ display: "grid", gridTemplateRows: "auto auto auto", gap: "10px", marginTop: "10px" }}>
                        <div>
                            <UI_Divider Text="Location" />
                            {/* <Controls_ScheduleManagement_Timetable_Selector
                                onRoomSelect={(Room) => Schedule_Weekly_Room_Set(Room?._id)}
                            /> */}
                            <div className='Floor_Utilization_Controls'>
                                <Controls_Map_Selector
                                    Map_Composition={Map_Composition}
                                    Building_Set={Selected_Building_Set}
                                    Floor_Set={Selected_Floor_Set}
                                    Selected_Building={Selected_Building}
                                    Selected_Floor={Selected_Floor}
                                    NoTime={true}
                                    Room_Show={true}
                                    Room_Selectable={true}
                                />
                            </div>
                        </div>
                        <div>
                            <UI_Divider Text="Range" />
                            <UI_Form Composition="ByTwo">
                                <UI_Input_Date
                                    id="Room_Utilization_Date_Start"
                                    Label_Text="Start date"
                                    Value="2025-01-01"
                                    onChange={(Data) => Room_Utilization_Handle_Filter(Data.target.value, "Date_Start")}
                                />
                                <UI_Input_Date
                                    id="Room_Utilization_Date_End"
                                    Label_Text="End date"
                                    Initial_Today={true}
                                    onChange={(Data) => Room_Utilization_Handle_Filter(Data.target.value, "Date_End")}
                                />
                            </UI_Form>
                        </div>
                        <UI_Divider />
                        <UI_Button
                            Text="Choose from interactive map"
                            OnClick={Room_Utilization_Handle_Map}
                        />
                        <UI_Button
                            Text="Generate report"
                            OnClick={Report_Room_Utilization}
                        />
                    </div>
                </>
                :
                ""
            }
            {Report_Type === "Logs" ?
                <>
                    <UI_Section_Title
                        Text="Activity logs"
                        Icon={<img src={Icon_Reports} />}
                        Margins={true}
                    />
                    <UI_Horizontal_Tabs
                        id="Log_Specifity"
                        Selectors={[
                            {
                                Icon: <UI_Icon Name="User_Edit" />,
                                Text: "Retrieve all"
                            },
                            {
                                Icon: <UI_Icon Name="User_Edit" />,
                                Text: "General search"
                            }
                            // ,
                            // {
                            //     Icon: <UI_Icon Name="Schedule" />,
                            //     Text: "Advanced search"
                            // }
                        ]}
                        onChange={(ID) => Logs_Handle_SearchType(ID)}
                        UIDs={["Get_All", "Search_General"]}
                        Selected="Tab_Search_General"
                        Components={[
                            <>
                            </>,
                            <>
                                <UI_Form>
                                    <UI_Input_Text
                                        id="Log_Search"
                                        Label_Text="Search term"
                                        onChange={(e) => Logs_Handle_Search(e.target.value)}
                                    />
                                    <UI_Input_Date
                                        id="Log_Range_Start"
                                        Label_Text="Starting date"
                                        onChange={Logs_Handle_Time}
                                        Value="2025-01-01"
                                    />
                                    <UI_Input_Date
                                        id="Log_Range_End"
                                        Label_Text="Ending date"
                                        Initial_Today={true}
                                        onChange={Logs_Handle_Time}
                                    />
                                    {/* <UI_Input_Text
                                        id="Log_Range_Start"
                                        Label_Text="Starting date"
                                        Input_Type='date'
                                        onChange={Logs_Handle_Time}
                                    />
                                    <UI_Input_Text
                                        id="Log_Range_End"
                                        Label_Text="Ending date"
                                        Input_Type='date'
                                        onChange={Logs_Handle_Time}
                                    /> */}
                                    {/* <UI_Dropdown
                                        id="Log_Filter_Category"
                                        Label_Text="Filter by module"
                                        Items={Logs_Categories.map((Item) => Item.Category)}
                                        InitialTitle="All"
                                    /> */}
                                    <UI_Dropdown_New
                                        id="Log_Filter_Action"
                                        Label_Text="Filter by action"
                                        Items={List_Logs_Actions}
                                        Item_Key="Title"
                                        InitialTitle="View all"
                                        onSelect={(Item, Index) => Logs_Handle_Filter_Action(Item, Index)}
                                    />
                                </UI_Form>
                            </>
                            // ,
                            // <>
                            //     <UI_Dropdown_New
                            //         id="Log_Filter_Document"
                            //         Label_Text="Filter by document type"
                            //         Items={Logs_Types_Documents}
                            //         Item_Key="Type"
                            //     />
                            // </>
                        ]}
                    />
                    <div>
                        <UI_Button
                            Text="Generate report"
                            OnClick={Report_Logs}
                        />
                    </div>

                </>
                :
                ""
            }
        </>
    );
}
